module.exports = __webpack_public_path__ + "static/media/智能宠物.75b1e965.png";